import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { Device } from '../types'
import DeviceDetachButton from './DeviceDetachButton'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface DeviceDetachAlertProps extends Omit<AlertProps, 'severity' | 'children'> {
  device: Device
}

export default function DeviceDetachAlert({ device, ...props }: DeviceDetachAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('device')

  /**
   * Indicates if the alert is dismissed.
   */
  const [dismissed, setDismissed] = useState<boolean>(false)

  return (
    <>
      {device?.asset?.projectId && !dismissed && (
        <Alert severity="warning" {...props} sx={{ '& .MuiAlert-message': { width: '100%' } }}>
          <AlertTitle sx={{ m: 0 }}>{t('DeviceDetachAlert.title')}</AlertTitle>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 1 }}>
            <DeviceDetachButton
              device={device}
              variant="outlined"
              color="inherit"
              size="small"
              startIcon={false}
              label={t('DeviceDetachAlert.yes')}
            />
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              onClick={() => setDismissed(true)}
            >
              {t('DeviceDetachAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
